var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayFlightR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1196_8861)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1196_8861",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 44,
  height: 44
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.7128 0L0 16L16 43.7128L43.7128 27.7128L27.7128 0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1196_8861)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.7152 13.856C35.0752 12.7475 33.5452 12.3375 32.4367 12.9775L24.8157 17.3775L11.4875 10.2924L8.71619 11.8924L18.5803 20.9775L10.9593 25.3775L7.2808 23.8062L5.20234 25.0062L9.38798 29.056L10.8023 34.7057L12.8808 33.5057L13.3593 29.5344L20.9803 25.1344L23.9162 38.2195L26.6875 36.6195L27.2157 21.5344L34.8367 17.1344C35.9452 16.4944 36.3552 14.9645 35.7152 13.856Z",
  fill: "#939CB0",
  fillOpacity: 0.8
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1196_8861"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(0 16) rotate(-30)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayFlightR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-flight-r.c63961c3ee3c03c3c4f6386d30c621ae.svg";